import Vue from 'vue';
import '@mdi/font/css/materialdesignicons.css';

// router
import router from './router.js';

// store
import store from './store';

// bus object
Vue.prototype.$bus = new Vue();

// helpers
window.isEmpty = (object) => (object == null || object == undefined);

// plugins
import './plugins/axios';
import './plugins/vueauth';
import './plugins/mixins';
import './plugins/editor';
import './plugins/qrcode';
import vuetify from './plugins/vuetify';

// instantiation
Vue.config.productionTip = false;
import EntryPoint from './EntryPoint.vue';

// global components
Vue.component('back-button', require('./components/BackButton.vue').default);

new Vue({
  store,
  router,
  vuetify,
  render: h => h(EntryPoint)
}).$mount('#app') 
